import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      backgroundColor: '#fff',
      position: 'sticky',
      top: 0,
      zIndex: 101,
    },
  },
  { name: 'Header' },
);

export default useStyles;
